import { NgModule } from "@angular/core";
import { SearchFilterComponent } from "./search-filter/search-filter.component";
import { PagerControlComponent } from "./controls/pager/pager-control.component";
import { AppPrimeNgModule } from "../app.primeng.module";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedMaterialModule } from "./shared-material.module";
import { SearchCompleteFilterComponent } from "./controls/search-complete-filter/search-complete-filter.component";
import { ResizableColumnControlComponent } from "./controls/resizable-column/resizable-column-control.component";
import { ResizableModule } from "angular-resizable-element";
import { PatientViewComponent } from "./patient-view/patient-view.component";
import { ValorizationEditControlComponent } from "./controls/valorization/valorization-edit/valorization-edit-control.component";
import { ValorizationItemAmountControlComponent } from "./controls/valorization/valorization-item-amount/valorization-item-amount-control.component";
import { DocumentationItemControlComponent } from "./controls/valorization/documentation-item/documentation-item-control.component";
import { ValorizationAmountControlComponent } from "./controls/valorization/valorization-amount/valorization-amount-control.component";
import { MedicalOrderEditControlComponent } from "./controls/medical-order/medical-order-edit/medical-order-edit-control.component";
import { ReferringPhysicianCompleteComponent } from "./autocomplete/referring-physician/referring-physician-autocomplete.component";
import { ReferringPhysicianInstituteComponent } from "./autocomplete/referring-physician-institute/referring-physician-institute.component";
import { MedicalFeeWithholdTaxDialogComponent } from "./dialogs/medical-fee-withhold-tax-dialog/medical-fee-withhold-tax-dialog.component";
import { MedicalFeeAmountComponent } from "./controls/medical-fee/medical-fee-amount/medical-fee-amount.component";
import { MedicalFeeTaxAmountDialogComponent } from "./dialogs/medical-fee-tax-amount-dialog/medical-fee-tax-amount-dialog.component";
import { MedicalFeeReportDialogComponent } from "./dialogs/medical-fee-report-dialog/medical-fee-report-dialog.component";
import { MedicalFeePaymentAliquotComponent } from "./medical-fee/medical-fee-payment-aliquot/medical-fee-payment-aliquot.component";
import { BillingInvoiceEditComponent } from "./billing/billing-invoice-edit/billing-invoice-edit.component";
import { BillingInvoiveViewComponent } from "./billing/billing-invoive-view/billing-invoive-view.component";
import { BillingInvoiceItemEntityEditComponent } from "./controls/billing-invoice/billing-invoice-item-entity-edit/billing-invoice-item-entity-edit.component";
import { BillingInvoiceEditControlComponent } from "./controls/billing-invoice/billing-invoice-edit/billing-invoice-edit.component";
import { BillingInvoiceItemEntityCreditEditComponent } from "./controls/billing-invoice/billing-invoice-item-entity-credit-edit/billing-invoice-item-entity-credit-edit.component";
import { ClientCompleteComponent } from "./autocomplete/client/client-autocomplete.component";
import { BillingInvoiceItemManualEditComponent } from "./controls/billing-invoice/billing-invoice-item-manual-edit/billing-invoice-item-manual-edit.component";
import { BillingInvoiceAssociateAutoCompleteComponent } from "./autocomplete/billing-invoice-associate-auto-complete/billing-invoice-associate-auto-complete.component";
import { ReceivedLabSampleComponent } from "./dialogs/received-lab-sample/received-lab-sample.component";
import { AppMaterialModule } from "../app.material.module";
import { MatDialogRef } from "@angular/material";
import { MatDialogModule } from "@angular/material/dialog";
import { PatientSearchComponent } from "./patient-search/patient-search.component";
import { MedicalOrderOperationControlComponent } from "./controls/medical-order-operation/medical-order-operation-control.component";
import { InvoiceCashDeskControlComponent } from "./controls/invoice-cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit-control.component";
import { InvoiceCashDeskEditComponent } from "./cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit.component";
import { InvoiceCashDeskViewComponent } from "./cash-desk/invoice-cash-desk-view/invoice-cash-desk-view.component";
import { TransactionReferenceComponent } from "./controls/transaction-reference/transaction-reference.component";
import { PatientReferringPhysicianControlComponent } from "./controls/patient/patient-referring-physician/patient-referring-physician-control.component";

@NgModule({
  declarations: [
    SearchFilterComponent,
    PagerControlComponent,
    SearchCompleteFilterComponent,
    ResizableColumnControlComponent,
    PatientViewComponent,
    PatientSearchComponent,
    MedicalOrderEditControlComponent,
    ValorizationEditControlComponent,
    ValorizationItemAmountControlComponent,
    DocumentationItemControlComponent,
    ValorizationAmountControlComponent,
    ReferringPhysicianCompleteComponent,
    ReferringPhysicianInstituteComponent,
    MedicalFeeAmountComponent,
    MedicalFeeTaxAmountDialogComponent,
    MedicalFeeReportDialogComponent,
    MedicalFeeWithholdTaxDialogComponent,
    MedicalFeePaymentAliquotComponent,
    BillingInvoiceEditComponent,
    BillingInvoiveViewComponent,
    BillingInvoiceItemEntityEditComponent,
    BillingInvoiceItemEntityCreditEditComponent,
    BillingInvoiceEditControlComponent,
    ClientCompleteComponent,
    BillingInvoiceItemManualEditComponent,
    BillingInvoiceAssociateAutoCompleteComponent,
    ReceivedLabSampleComponent,
    TransactionReferenceComponent,
    PatientReferringPhysicianControlComponent,
    MedicalOrderOperationControlComponent,
    InvoiceCashDeskControlComponent,
    InvoiceCashDeskEditComponent,
    InvoiceCashDeskViewComponent
  ],
  providers: [
    DatePipe
  ],
  imports: [
    CommonModule,
    ResizableModule,
    AppPrimeNgModule,
    SharedMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    AppMaterialModule,
  ],
  exports: [
    CommonModule,
    AppPrimeNgModule,
    PagerControlComponent,
    SearchFilterComponent,
    SharedMaterialModule,
    PatientViewComponent,
    PatientSearchComponent,
    SearchCompleteFilterComponent,
    ResizableColumnControlComponent,
    MedicalOrderEditControlComponent,
    TransactionReferenceComponent,
    ReferringPhysicianCompleteComponent,
    ReferringPhysicianInstituteComponent,
    ResizableModule,
    ValorizationEditControlComponent,
    ValorizationAmountControlComponent,
    ValorizationItemAmountControlComponent,
    DocumentationItemControlComponent,
    MedicalFeeAmountComponent,
    MedicalFeePaymentAliquotComponent,
    BillingInvoiceEditControlComponent,
    BillingInvoiceEditComponent,
    BillingInvoiveViewComponent,
    BillingInvoiceItemEntityEditComponent,
    BillingInvoiceItemEntityCreditEditComponent,
    BillingInvoiceItemManualEditComponent,
    ClientCompleteComponent,
    BillingInvoiceAssociateAutoCompleteComponent,
    AppMaterialModule,
    ReceivedLabSampleComponent,
    PatientReferringPhysicianControlComponent,
    MedicalOrderOperationControlComponent,
    InvoiceCashDeskControlComponent,
    InvoiceCashDeskEditComponent,
    InvoiceCashDeskViewComponent
  ],
  entryComponents: [
    MedicalFeeWithholdTaxDialogComponent,
    MedicalFeeTaxAmountDialogComponent,
    MedicalFeeReportDialogComponent,
    ReceivedLabSampleComponent,
  ],
})
export class SharedModule {}
